<template>
  <vx-card v-show="isCardActiveLocal" class="mt-3">
    <div v-if="question.quizDetails.isGraded" class="vx-row">
      <div class="flex flex-wrap items-center justify-center">
        <p class="ml-4 mr-2">Score: </p>
        <p><strong>{{ answer.questionAchievedMarks + " / " + (answer.questionTotalMarks != 0 ? answer.questionTotalMarks : answer.textOriginalTotalPoints != 0 ? answer.textOriginalTotalPoints : answer.tableOriginalTotalPoints != 0 ? answer.tableOriginalTotalPoints : 0) }}</strong></p>
      </div>
    </div>
    <div v-if="answer.assessorComment" class="mt-2 vx-row">
      <div class="vx-col flex-1">
        <label><strong>{{ viewOnly ? "Teacher Comment:" : "Assessor Comment:" }}</strong></label>
        <vs-textarea readOnly v-model="answer.assessorComment" />
      </div>
    </div>
    <div v-if="!viewOnly" class="mt-2 vx-row">
      <div class="vx-col flex-1">
        <label>Your Comment:</label>
        <vs-textarea v-model="answer.studentComment" />
      </div>
    </div>
  </vx-card>
</template>

<script>
  import vSelect from 'vue-select'
  export default {
    components: {
      'v-select': vSelect
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      question: {
        type: Object,
        required: false
      },
      answer: {
        type: Object,
        required: false
      },
      viewOnly: {
        type: Boolean,
        required: false
      }
    },
    data() {
      return {
        
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            
          }
        }
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          
        }
      }
    },
    mounted() {
      if(this.answer && this.answer.textOriginalTotalPoints != 0 && this.answer.questionAchievedMarks == 0){
        this.answer.questionAchievedMarks = "";
      }

      if(this.answer && this.answer.tableOriginalTotalPoints != 0 && this.answer.questionAchievedMarks == 0){
        this.answer.questionAchievedMarks = "";
      }
    },
  }

</script>

<style lang="scss">

</style>
